/**
 * 应用顶级组件
 * @author luoying, chenqunfeng
 * @since 18/06/06
 */

import './store.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Searchbox from 'containers/searchbox';
// import StoreTopics from 'containers/store-topics';
import StoreTabs from 'containers/store-tabs';
import StoreFilters from 'containers/store-filters';
import StoreTpls from 'containers/store-tpls';
import StoreTplModal from 'containers/store-tpl-modal';
import BottomStatus from 'components/store-tpls/bottom-status';
import NavBreadcrumb from 'components/store-tpls/nav-breadcrumb';
import { isModuleHidden } from 'utils/hidden-modules';
import { isInEditorIframe } from 'utils/env';

const inEditorIframe = isInEditorIframe();

class Store extends Component {
  static propTypes = {
    user: PropTypes.object,
  };

  renderLoading() {
    return (
      <div className="store-tpls-wrapper">
        <div className="loading-status">
          <BottomStatus status={1} />
        </div>
      </div>
    );
  }

  renderInEditorStore(user) {
    return (
      <div className="store">
        {!user.userId && !user.guest ? (
          this.renderLoading()
        ) : (
          <div className="body">
            <StoreTabs />
            <StoreFilters />
            {!user.userId && !user.guest ? this.renderLoading() : <StoreTpls />}
          </div>
        )}
        {!user.userId && !user.guest ? null : <StoreTplModal />}
      </div>
    );
  }

  render() {
    const { user } = this.props;
    return inEditorIframe ? (
      this.renderInEditorStore(user)
    ) : (
      <div className="store">
        {!isModuleHidden('header') && (
          <div className="header">
            <Searchbox />
            <NavBreadcrumb />
            {/* <StoreTopics /> */}
          </div>
        )}
        <div className="body">
          <StoreTabs />
          <StoreFilters />
          {!user.userId && !user.guest ? this.renderLoading() : <StoreTpls />}
        </div>
        {!user.userId && !user.guest ? null : <StoreTplModal />}
      </div>
    );
  }
}

export default Store;
